import React, { RefObject } from 'react';

interface GameCanvasProps {
  canvasRef: RefObject<HTMLCanvasElement | null>;
}

const GameCanvas: React.FC<GameCanvasProps> = ({ canvasRef }) => {
  return (
    <canvas
      ref={canvasRef}
      style={{ 
        position: 'absolute', 
        top: 0, 
        left: 0, 
        width: '100%', 
        height: '100%',
        zIndex: 1,
        touchAction: 'none'
      }}
    />
  );
};

export default GameCanvas; 